import CapacityInput from "./Capacity";
export default CapacityInput;
